import { gql } from '@apollo/client';

export const GET_ALL_PRODUCTS = gql`
    query GET_ALL_PRODUCTS(
        $productID: String!
        $sessionID: String
        $customerID: String
    ) {
        getAllAvailableProducts(
            productGroup: $productID
            sessionId: $sessionID
            customerId: $customerID
        ) {
            imageId
            recommendedProducts {
                name
                productId
                productDesc
                productGroup
                productOrder
                productCategory
                sellingPoints
                pickedForYouContent
                businessSelectorLearnMoreUrl
                applyUrl
                learnMore
                imageId
                allProductOrder
            }
        }
    }
`;
